export const opacities = {
  'opacity-1': '100%',
  'opacity-2': '85%',
  'opacity-3': '20%',
  'opacity-4': '0%',
};
